import React from 'react';
import PropTypes from 'prop-types';

import Dialog from '../../views/fragments/dialog';
import Button from '../../views/fragments/button';

export default class ValidateDialog extends React.Component {

  static propTypes = {
    showDialog: PropTypes.bool.isRequired,
    showSubmit: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
  };

  static defaultProps = {
    showDialog: false,
    showSubmit: false,
  };

  handleSubmit() {
    const {onSubmit} = this.props;
    onSubmit();
  }

  handleClose() {
    const {onClose} = this.props;
    onClose();
  }

  get submitComponent() {
    const {showSubmit} = this.props;

    if (!showSubmit) {
      return null;
    }

    return (
      <div>
        <div>
          Do you want to continue?
        </div>
        <div>
          <Button
           btnStyle="info"
           pullRight
           onClick={
            this.handleClose.bind(this)}>
            No
          </Button>
          <Button
           btnStyle="info"
           pullRight
           onClick={
            this.handleSubmit.bind(this)}>
            Yes
          </Button>
        </div>
      </div>
    );
  }

  render() {
    const {showDialog} = this.props;

    if (!showDialog) {
      return null;
    }

    const {children} = this.props;
    return (
      <Dialog
       onClose={
        this.handleClose.bind(this)}
       width="42rem"
       closeOnBlur={false}>
        {children}
        {this.submitComponent}
      </Dialog>
    );
  }

}



// WEBPACK FOOTER //
// ./src/components/validate-dialog/index.js